import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { CardDisplayProvider } from './games/unmatched/ui/cardDisplay.js';
import './styles.css';
import './portal/portal.css';

const root = document.getElementById('root');
if (!root) throw new Error('Chýba #root');

createRoot(root).render(
  <StrictMode>
    <CardDisplayProvider>
      <App />
    </CardDisplayProvider>
  </StrictMode>,
);
